import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Link,
  Stack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MAIN_NAV, PRODUCT_CATEGORIES } from '../../config/navigation';
import { SERVICES } from '../../data/services';

const SUBMENUS = {
  services: SERVICES.map(s => ({ label: s.title, href: '/services' })),
  products: [
    ...PRODUCT_CATEGORIES.map(c => ({
      label: c.label,
      href: `/products/${c.slug}`,
    })),
  ],
  projects: [
    { label: 'Galería de proyectos', href: '/projects' },
    { label: 'Siesa QR App', href: '/siesa-qr-app' },
  ],
};

export default function MobileMenu({ isOpen, onClose }) {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement="left"
      size="xs"
      variant="publicSurface"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton
          aria-label="Cerrar el menú"
          minW="44px"
          minH="44px"
        />
        <DrawerHeader borderBottomWidth="1px" fontSize="md">
          Menú
        </DrawerHeader>
        <DrawerBody px={0} py={4}>
          <Stack as="nav" aria-label="Navegación móvil" spacing={0}>
            {MAIN_NAV.map(item =>
              item.menu ? (
                <Accordion key={item.label} allowToggle>
                  <AccordionItem border="none">
                    <AccordionButton
                      px={6}
                      py={3}
                      minH="44px"
                      fontWeight={600}
                      fontSize="sm"
                    >
                      <Box flex="1" textAlign="left">
                        {item.label}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={2} pl={9} pr={6}>
                      <Stack spacing={0}>
                        {SUBMENUS[item.menu].map(entry => (
                          <Link
                            key={entry.label}
                            as={RouterLink}
                            to={entry.href}
                            onClick={onClose}
                            py={2.5}
                            minH="44px"
                            fontSize="sm"
                            color="text.secondary"
                            _hover={{ color: 'accent.default' }}
                          >
                            {entry.label}
                          </Link>
                        ))}
                      </Stack>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              ) : (
                <Link
                  key={item.label}
                  as={RouterLink}
                  to={item.href}
                  onClick={onClose}
                  px={6}
                  py={3}
                  minH="44px"
                  fontWeight={600}
                  fontSize="sm"
                  _hover={{ bg: 'surface.muted', color: 'accent.default' }}
                >
                  {item.label}
                </Link>
              )
            )}
          </Stack>

          <Box px={6} pt={6}>
            <Button
              as={RouterLink}
              to="/contact?subject=quote"
              onClick={onClose}
              variant="primary"
              w="full"
            >
              Solicitar cotización
            </Button>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
